exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".menu-active {\n  background-color: #007BFF; }\n\n.menu-mobile.color-scheme-dark {\n  background-image: linear-gradient(to bottom, #1b55e2 100%, #1b55e2 100%);\n  background-repeat: repeat-x;\n  background-color: #007bff; }\n\n.menu-description {\n  font-size: 12px !important;\n  color: white; }\n\n.menu-w.color-style-bright {\n  background-image: linear-gradient(to bottom, #1b55e2 100%, #1b55e2 100%); }\n\n@media (max-width: 1024px) {\n  .menu-w {\n    display: flex !important; }\n    .menu-w.color-scheme-dark.color-style-bright ul.main-menu .icon-w {\n      color: #babed0 !important;\n      padding: 10px 5px !important; } }\n", ""]);

// exports
